// Redirecciones de entrada y de portal para los `beforeLoad`. Deciden sobre el estado de
// `ensureLoaded`; con el perfil en error no redirigen y la pantalla ofrece reintentar.
import { redirect } from '@tanstack/react-router';
import {
    resolveAccess,
    type AccessState,
    type SessionSource,
    type SessionState,
} from '@/lib/authGuard';
import {
    entryTarget,
    noAccessTarget,
    portalGuardTarget,
    selectorTarget,
    type AccessTarget,
    type PortalId,
} from './portalAccess';

type AccessSource = SessionSource<SessionState & { permissions: ReadonlySet<string> }>;

async function loadAccess(auth: AccessSource): Promise<AccessState> {
    return resolveAccess(await auth.ensureLoaded());
}

function redirectIfNeeded(target: AccessTarget | null): void {
    if (target) throw redirect({ to: target });
}

export async function redirectFromEntry(auth: AccessSource): Promise<void> {
    redirectIfNeeded(entryTarget(await loadAccess(auth)));
}

export async function redirectFromSelector(auth: AccessSource): Promise<void> {
    redirectIfNeeded(selectorTarget(await loadAccess(auth)));
}

export async function requirePortal(auth: AccessSource, portalId: PortalId): Promise<void> {
    redirectIfNeeded(portalGuardTarget(portalId, await loadAccess(auth)));
}

export async function redirectFromNoAccess(auth: AccessSource): Promise<void> {
    redirectIfNeeded(noAccessTarget(await loadAccess(auth)));
}
